import { Component, Input, OnChanges, OnInit, SimpleChanges, ChangeDetectionStrategy } from '@angular/core';

@Component({
    selector: 'lib-question-answer-option-code',
    templateUrl: './question-answer-option-code.component.html',
    styleUrls: ['./question-answer-option-code.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class QuestionAnswerOptionCodeComponent implements OnInit, OnChanges {
  @Input() public index: number;
  @Input() public numeric = false;

  private readonly START_CHART = 'A';

  public code: string;

  constructor() { }

  ngOnInit(): void {
    this.setCode();
  }

  ngOnChanges(changes: SimpleChanges): void {
    const indexChanged = changes['index'] && changes['index'].currentValue !== changes['index'].previousValue;
    const numericChanged = changes['numeric'] && changes['numeric'].currentValue !== changes['numeric'].previousValue;

    if (indexChanged || numericChanged) {
      this.setCode();
    }
  }

  private setCode(): void {
    if (this.numeric) {
      this.code = (this.index + 1).toString();
      return;
    }

    const startCharCode = this.START_CHART.charCodeAt(0);
    this.code = String.fromCharCode(startCharCode + this.index)
  }

}
